// Inertia defaults
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '/vendor/tightenco/ziggy';

// Vendors
import VueAwesomePaginate from 'vue-awesome-paginate';
import GlobalComponents from './global-components';
import Vue3Toastify from 'vue3-toastify';
import * as Sentry from '@sentry/vue';

// Custom
import '@scss/shared.scss';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
	title: (title) => `${title} - ${appName}`,
	resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
	setup({ el, App, props, plugin }) {
		const app = createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(ZiggyVue)
			.use(VueAwesomePaginate)
			.use(Vue3Toastify, {
				icon: false,
				theme: 'colored',
				autoClose: 3000,
			})
			.use(GlobalComponents);

		// Initialize Sentry
		Sentry.init({
			app,
			dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN, // Use your Sentry DSN from .env
			relase: import.meta.env.VITE_APP_VERSION,
			environment: import.meta.env.MODE,
			integrations: [],
			tracesSampleRate: 1.0,
		});

		return app.mount(el);
	},
	progress: {
		color: '#4B5563',
	},
});
